import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input, Switch } from '@progress/kendo-react-inputs';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import AccountsList from './AccountsList';
import WiseconnStationsList from './WiseconnStationsList';
import AgZoomStationsList from './AgZoomStationsList';


class StationForm extends Component {
    constructor(props) {
        super(props);
    }


    render() {

        return (
            <div className='modal-form-inputs-wrap'>
                <div className="modal-form-inputs-wrap-row">
                    <DropDownList
                        label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.api', defaultMessage: 'API' })}
                        name='api'
                        data={[
                            "Ech2o",
                            "Zentra",
                            "Fieldclimate",
                            "Wiseconn",
                            "Agronic",
                            "Talgil",
                            "Davis",
                            "Qampo",
                            "Weenat",
                            "Prismab",
                            "Agroop",
                            'E-Smart',
                            'Galcon',
                            'Ag-Zoom',
                            'Dragino'
                        ]}
                        value={this.props.station.api}
                        onChange={this.props.handleChange} />

                    {['Qampo', 'Prismab', 'Wiseconn', 'Galcon', 'Agronic', 'Ag-Zoom'].indexOf(this.props.station.api) === -1 && <Input
                        required={true}
                        name='name'
                        label={['Davis', 'Weenat', 'Agroop'].indexOf(this.props.station.api) === -1 ? this.props.intl.formatMessage({ id: 'app.stations.stationForm.name', defaultMessage: 'NAME' }) : this.props.intl.formatMessage({ id: 'app.stations.stationForm.accName', defaultMessage: 'ACCOUNT NAME' })}
                        value={this.props.station.name}
                        onChange={this.props.handleChange} />}
                </div>

                {this.props.station.api === 'Dragino' ? <>
                    <div className="modal-form-inputs-wrap-row">
                        <Input
                            required={true}
                            name={'serial'}
                            label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.imei', defaultMessage: 'IMEI' })}
                            value={this.props.station.serial}
                            onChange={this.props.handleChange} />
                        <DropDownList
                            label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.model', defaultMessage: 'MODEL' })}
                            name='model'
                            data={this.props.draginoModels || []}
                            textField='label'
                            dataItemKey='model'
                            value={this.props.station.model}
                            onChange={this.props.handleChange} />
                    </div>
                    <div className="modal-form-inputs-wrap-row">
                        <Input
                            name='site'
                            label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.site', defaultMessage: 'SITE' })}
                            value={this.props.station.site}
                            onChange={this.props.handleChange} />
                    </div>
                    <p className='text-sm text-gray-500'>
                        {this.props.intl.formatMessage({ id: 'app.stations.dragino.formHint', defaultMessage: 'The node is registered in AWS IoT Core and you receive the commands to paste into it over its serial console.' })}
                    </p>
                </> : ['Wiseconn', 'Ag-Zoom'].indexOf(this.props.station.api) === -1 ? <>
                    {['Davis', 'Weenat', 'Agroop'].indexOf(this.props.station.api) === -1 ?
                        <div className="modal-form-inputs-wrap-row">
                            {this.props.station.api === 'Qampo' ? <Input
                                required={true}
                                name={'username'}
                                label={this.props.intl.formatMessage({ id: 'app.userGrid.userModel.username', defaultMessage: 'USERNAME' })}
                                value={this.props.station.username}
                                onChange={this.props.handleChange} /> :
                                this.props.station.api === 'Prismab' ? <Input
                                    required={true}
                                    name={'email'}
                                    label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.email', defaultMessage: 'EMAIL' })}
                                    value={this.props.station.email}
                                    onChange={this.props.handleChange} /> :
                                <Input
                                    required={true}
                                    name={'serial'}
                                    label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.serialNo', defaultMessage: 'SERIAL NO' })}
                                    value={this.props.station.serial}
                                    onChange={this.props.handleChange} />}

                            {['Agronic', 'E-Smart', 'Talgil', 'Galcon', 'Ag-Zoom'].indexOf(this.props.station.api) === -1 && <Input
                                // Hide password field for Agronic, Talgil, and E-Smart APIs
                                required={true}
                                name='password'
                                label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.password', defaultMessage: 'PASSWORD' })}
                                value={this.props.station.password}
                                onChange={this.props.handleChange} />}
                        </div> :

                        <div className="modal-form-inputs-wrap-row">
                            <Input
                                required={true}
                                name='api_key'
                                label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.apiKey', defaultMessage: 'API KEY' })}
                                value={this.props.station.api_key}
                                onChange={this.props.handleChange} />

                            {this.props.station.api === 'Davis' &&
                                <Input
                                    required={true}
                                    name='secret_key'
                                    label={this.props.intl.formatMessage({ id: 'app.stations.stationForm.secretKey', defaultMessage: 'SECRECT KEY' })}
                                    value={this.props.station.secret_key}
                                    onChange={this.props.handleChange} />}
                        </div>}

                    <div className="modal-form-inputs-wrap-row">
                        <div style={{ display: 'flex', flexFlow: 'column' }}>
                            <label style={{ color: 'gray', fontSize: '.8em', paddingTop: '5px' }}>
                                {this.props.intl.formatMessage({ id: 'app.stations.stationForm.downloadDataSince', defaultMessage: 'DOWNLOAD DATA SINCE' })}
                            </label>
                            <DateTimePicker
                                name='download_since'
                                value={this.props.station.download_since}
                                calendarSettings={{ views: 1 }}
                                popupSettings={this.popupSettings}
                                onChange={this.props.handleChange}
                            />
                        </div>
                        {this.props.station.api === 'Davis' &&
                            <div className='flex p-4 items-end'>
                                <label
                                    title={this.props.intl.formatMessage({ id: 'app.stations.stationForm.message', defaultMessage: 'Check if account have pro subscription' })}
                                    style={{ color: 'gray', paddingTop: '5px' }}>
                                    {this.props.intl.formatMessage({ id: 'app.stations.stationForm.prosub', defaultMessage: 'PRO SUBSCRIPTION' })}
                                </label>
                                <span className='pl-4'>
                                    <Switch
                                        name='pro_subscription'
                                        checked={this.props.station.pro_subscription}
                                        onChange={this.props.handleChange}
                                    />
                                </span>
                            </div>}
                    </div>

                    {this.props.station.api === 'Davis' &&
                        <AccountsList
                            accounts={this.props.davisAccounts}
                            deleteAccount={this.props.deleteDavisAccount}
                            api={'Davis'}
                        />
                    }

                    {this.props.station.api === 'Qampo' &&
                        <AccountsList
                            accounts={this.props.qampoAccounts}
                            deleteAccount={this.props.deleteQampoAccount}
                            api={'Qampo'}
                        />
                    }

                    {this.props.station.api === 'Weenat' &&
                        <AccountsList
                            accounts={this.props.weenatAccounts}
                            deleteAccount={this.props.deleteWeenatAccount}
                            api={'Weenat'}
                        />
                    }

                    {this.props.station.api === 'Prismab' &&
                        <AccountsList
                            accounts={this.props.prismabAccounts}
                            deleteAccount={this.props.deletePrismabAccount}
                            api={'Prismab'}
                        />
                    }

                    {this.props.station.api === 'Agroop' &&
                        <AccountsList
                            accounts={this.props.agroopAccounts}
                            deleteAccount={this.props.deleteAgroopAccount}
                            api={'Agroop'}
                        />
                    }

                </> :
                    <>
                        {this.props.station.api === 'Ag-Zoom' &&
                            <AgZoomStationsList
                                addStation={this.props.addStation}
                                addingDevice={this.props.addingDevice}
                            />
                        }
                        {this.props.station.api === 'Wiseconn' &&
                            <WiseconnStationsList
                                addStation={this.props.addStation}
                            />
                        }

                    </>
                }

            </div>
        );
    }
}

export default StationForm;